import { Stack } from '@mui/material';
import PageHeaderBackLink from 'layout/pages/PageHeaderBackLink';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import type { FC } from 'react';

const ClientEditPageHeader: FC = () => (
  <PageHeaderWrapper>
    <Stack spacing={2}>
      <PageHeaderBackLink to='/clients' name='Клиенты' />
      <PageHeaderText text='Редактирование клиента' />
    </Stack>
  </PageHeaderWrapper>
);

export default ClientEditPageHeader;
